<div class="ai-settings-container">
    <div class="section-header">
        <h2>Knowledge Documents</h2>
        <p class="section-description">
            Manage knowledge documents used by the AI assistant to answer questions.
            These documents are automatically searched and included in AI responses when relevant.
        </p>
    </div>

    <div class="actions-bar">
        <button mat-raised-button color="primary" (click)="openCreateModal()">
            <mat-icon>add</mat-icon>
            Add Document
        </button>
        <span class="document-count" *ngIf="totalDocuments > 0">
            {{ totalDocuments }} document{{ totalDocuments !== 1 ? 's' : '' }}
        </span>
    </div>

    <div class="loading-container" *ngIf="isLoading$ | async">
        <mat-spinner diameter="40"></mat-spinner>
        <span>Loading documents...</span>
    </div>

    <div class="empty-state" *ngIf="!(isLoading$ | async) && (documents$ | async)?.length === 0">
        <mat-icon>description</mat-icon>
        <p>No knowledge documents yet</p>
        <span>Add your first document to help the AI assistant answer questions.</span>
    </div>

    <div class="documents-list" *ngIf="!(isLoading$ | async) && (documents$ | async)?.length > 0">
        <div class="document-card" *ngFor="let doc of documents$ | async">
            <div class="document-header">
                <h3 class="document-title">{{ doc.title }}</h3>
                <div class="document-actions">
                    <button mat-icon-button (click)="openEditModal(doc)" matTooltip="Edit">
                        <mat-icon>edit</mat-icon>
                    </button>
                    <button mat-icon-button color="warn" (click)="deleteDocument(doc)" matTooltip="Delete">
                        <mat-icon>delete</mat-icon>
                    </button>
                </div>
            </div>
            <p class="document-content">{{ truncateContent(doc.content, 200) }}</p>
            <div class="document-meta">
                <span *ngIf="doc.created_at">
                    <mat-icon>calendar_today</mat-icon>
                    Created: {{ formatDate(doc.created_at) }}
                </span>
                <span *ngIf="doc.updated_at">
                    <mat-icon>update</mat-icon>
                    Updated: {{ formatDate(doc.updated_at) }}
                </span>
            </div>
        </div>
    </div>
</div>
